import { getFullTime } from "../lib/dateFormater"
import fetchService from "../lib/fetchService"
import { ISession } from "../lib/globalInterfaces"
import { IRank, RankDTO } from "./RankDTO"

export class SessionDTO {
  circuit_key: number = -1
  circuit_short_name: string = ''
  country_code: string = ''
  country_key: number = -1
  country_name: string = ''
  date_end: Date = new Date()
  date_start: Date = new Date()
  gmt_offset: string = ''
  location: string = ''
  meeting_key: number = -1
  session_key: number = -1
  session_name: string = ''
  session_type: string = ''
  year: number = -1

  ranks: RankDTO[] = []
  
  constructor(data: ISession) {
    this.init(data)
  }

  init(data: ISession) {
    this.circuit_key = data.circuit_key || -1
    this.circuit_short_name = data.circuit_short_name || ''
    this.country_code = data.country_code || ''
    this.country_key = data.country_key || -1
    this.country_name = data.country_name || ''
    this.date_end = data.date_end ? new Date(data.date_end) : new Date()
    this.date_start = data.date_start ? new Date(data.date_start) : new Date()
    this.gmt_offset = data.gmt_offset || ''
    this.location = data.location || ''
    this.meeting_key = data.meeting_key || -1
    this.session_key = data.session_key || -1
    this.session_name = data.session_name || ''
    this.session_type = data.session_type || ''
    this.year = data.year || -1
  }

  async load(session_key: number) {
    this.session_key = session_key
    const data: IRank[] = await fetchService.get('/api/ranking/' + this.session_key)
    this.ranks = data.map(item => new RankDTO(item))
  }

  getLink() {
    return `/${this.year}/${this.circuit_short_name}/${this.session_key}`
  }

  getStartHumanDate() {
    return getFullTime(this.date_start, this.gmt_offset)
  }

  getEndHumanDate() {
    return getFullTime(this.date_end, this.gmt_offset)
  }
}
